<script setup lang="ts">
import { state } from '../lib/store'
</script>

<template>
  <div class="status">
    <span v-if="state.busy" class="spinner"></span>
    <span class="msg">{{ state.status }}</span>
    <div class="spacer"></div>
    <span class="env" :class="{ live: state.insideOffice }">
      {{ state.insideOffice ? 'Excel connected' : 'Preview (no Excel)' }}
    </span>
  </div>
</template>

<style scoped>
.status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-top: 1px solid var(--line);
  background: var(--bg-soft);
  font-size: 11px;
  color: var(--muted);
}
.msg { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.env {
  flex: none;
  padding: 1px 7px;
  border-radius: 10px;
  background: #eee;
}
.env.live {
  background: #e3f3e3;
  color: #2e7d32;
}
.spinner {
  width: 11px;
  height: 11px;
  border: 2px solid var(--line);
  border-top-color: var(--brand);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  flex: none;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
